import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=2c40946a&scoped=true"
import script from "./topBar.vue?vue&type=script&lang=js"
export * from "./topBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40946a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\word\\aiks-big-screen-v1-shanxi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c40946a')) {
      api.createRecord('2c40946a', component.options)
    } else {
      api.reload('2c40946a', component.options)
    }
    module.hot.accept("./topBar.vue?vue&type=template&id=2c40946a&scoped=true", function () {
      api.rerender('2c40946a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/topBar.vue"
export default component.exports